module.exports = __webpack_public_path__ + "img/close-second.33d2b343.svg";